module.exports = __webpack_public_path__ + "img/failed.a70d97fd.png";